<template>
  <nav class="col-12 col-navbar d-lg-flex align-items-start flex-column bg-dark px-0">
    <div class="navbar navbar-expand navbar-dark flex-grow-1 align-items-start flex-column w-100">
      <ul class="nav navbar-nav flex-column flex-grow-1 w-100">
        <li class="nav-item nav-item-active">
          <router-link to="/draws/dashboard" class="nav-link">{{ draftName }}</router-link>
          <ul class="pl-0">
            <li
              v-for="event in events"
              :key="event.id"
              class="nav-item"
            >
              <router-link
                :to="'/calculators/' + event.event_id"
                :class="['nav-link', { active: event.event_id === currentEventId }]"
              >
                {{ event.name }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'CalculatorSidebar',
  props: {
    draftName: { type: String, default: '' },
    events: { type: Array, default: () => [] },
    currentEventId: { type: Number, default: null }
  }
})
</script>

<style lang="scss" scoped>
.col-navbar {
  flex: 0 1 220px;
  max-width: 220px;

  .nav-link {
    font-size: 0.9375rem;
    white-space: initial !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Calculators/CalculatorSidebar.vue